export default "__VITE_ASSET__CVQYZbS1__"